import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const HeartStickerShape = ({ width = 80, height = 80, style }: BaseSVGType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      id="Capa_1"
      viewBox="0 0 455 455"
      xmlSpace="preserve"
      width={width}
      height={height}
      style={style}
    >
      <g>
        <path
          fill="#E44670"
          d="M333.63,20c-3.44,0-6.86,0.14-10.23,0.43l-95.81,414.52C232.8,432.1,455,309.38,455,141.37   C455,74.34,400.66,20,333.63,20z"
        />
        <path
          fill="#FF6288"
          d="M323.4,20.43c51.29,5.19,91.6,57.35,91.6,120.94c0,167.84-182.76,290.48-187.41,293.58   c-0.06,0.03-0.09,0.05-0.09,0.05S0,311.37,0,141.37C0,74.34,54.34,20,121.37,20c45.7,0,85.44,25.3,106.13,62.63   C246.63,48.11,282.05,23.88,323.4,20.43z"
        />
      </g>
    </svg>
  );
};

export default HeartStickerShape;
